import { Box, Container, Divider, Stack, Typography } from "@mui/material";

const Footer = () => (
  <Box sx={{ mt: 6, pb: 4 }}>
    <Divider sx={{ mb: 3 }} />
    <Container maxWidth="xl">
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
      >
        <Typography variant="body2" color="text.secondary">
          SmartPower Solutions Corporation
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Energy intelligence dashboard · 2026
        </Typography>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
